// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c715e02e","453":"50bad6c1","667":"555c9479"}[chunkId] + ".chunk.js";
};